"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retriveRemValueForHeightOption = exports.isValidInteractable = exports.convertRemToPixels = exports.buildAnalyticsEntityName = void 0;
require("core-js/modules/es6.regexp.split.js");
require("core-js/modules/es6.regexp.replace.js");
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _expandableContentModule = require("./expandable-content.module.css");
/**
 * @todo This should probably come from 'base-styles'
 * We need to avoid getComputedStyle as it synchronously forces a layout reflow which reduces performance.
 * @see {@link https://stackoverflow.com/questions/36532307/rem-px-in-javascript}
 */
var convertRemToPixels = function convertRemToPixels(rem) {
  return rem * 16;
};

/**
 * For content that is toggleable itself, ensure that we do not hijack behavior
 * of nested interactbles like links or buttons should they be present.
 */
exports.convertRemToPixels = convertRemToPixels;
var isValidInteractable = function isValidInteractable(event) {
  var currentTarget = event.currentTarget,
    target = event.target;
  var nodeName = target.nodeName;
  return nodeName === 'A' || nodeName === 'BUTTON' && target !== currentTarget;
};

/**
 * Retreive the calculated rem value derived for the height option.
 * These values are calculated statically within the 2D array export from the stylesheet.
 */
exports.isValidInteractable = isValidInteractable;
var parsedOptionsArray = _expandableContentModule.COLLAPSED_HEIGHT_OPTIONS.split(/[ ,]+/);
var retriveRemValueForHeightOption = function retriveRemValueForHeightOption(collapsedHeightOption) {
  return parsedOptionsArray[(0, _findIndex2.default)(parsedOptionsArray, function (option) {
    return option === collapsedHeightOption;
  }) + 1];
};
exports.retriveRemValueForHeightOption = retriveRemValueForHeightOption;
var buildAnalyticsEntityName = function buildAnalyticsEntityName(name) {
  return name === null || name === void 0 ? void 0 : name.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};
exports.buildAnalyticsEntityName = buildAnalyticsEntityName;